<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <form [formGroup]="actionForm">
        <aside class="initial-action">
          <label class="other-operators">
            <input type="text" [formControl]="actionControl" placeholder="Action" required>
            <span class="char-count" [class.over-limit]="actionControl.value?.length > 30">
              {{ actionControl.value?.length || 0 }}/30
            </span>
            @if (actionControl.touched && actionControl.hasError('maxlength')) {
              <span class="field-error">{{ actionMaxLengthError }}</span>
            }
          </label>

          <mat-button-toggle-group class="kyloe-rule-toggle" [formControl]="commentsModeControl"
                                   hideSingleSelectionIndicator="true" aria-label="Comments mode">
            <mat-button-toggle value="SPECIFY"
                               matTooltip="Specify comments on the added Note"
                               matTooltipPosition="left"
                               [matTooltipShowDelay]="500">Specify</mat-button-toggle>
            <mat-button-toggle value="RULE_SUMMARY"
                               matTooltipPosition="right"
                               matTooltip="Populates comments on the Note with summary of Rule actions"
                               [matTooltipShowDelay]="500">Rule Summary</mat-button-toggle>
          </mat-button-toggle-group>

          @if (commentsModeControl.value === 'SPECIFY') {
            <label class="other-operators">
              <textarea [formControl]="commentsControl" placeholder="Comments" rows="4"></textarea>
            </label>
            <div class="message tip">
              <i class="material-icons notranslate">info</i>
              Tip: Use $&#123;RULE_NAME&#125; or $&#123;RULE_SUMMARY&#125; as placeholders — they are replaced when the Rule runs.
            </div>
          }

          @if (commentsModeControl.value === 'RULE_SUMMARY') {
            <div class="message tip">
              <i class="material-icons notranslate">info</i>
              Comments will be auto-populated from this Rule's actions when the Rule runs.
            </div>
          }

          <div class="checkbox-container">
            <label class="checkbox-label">
              <input type="checkbox" class="kyloe-checkbox" [formControl]="isDeletedControl">
              <span>Hidden from Bullhorn view?</span>
            </label>
          </div>

          <app-action-warning-block
            [message]="warningMessage"
            [actionType]="dataRulesService.actionOpName(dataRulesService.actionOperators.INSERT)"
          ></app-action-warning-block>

          <div class="message tip">
            <i class="material-icons notranslate">info</i>
            Will create a new Note associated with {{primaryEntity}} records that match your criteria.
          </div>
        </aside>
      </form>
    </li>
  </ul>
</section>
